import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";

// Arabic translation file (ar.json) can be added later; enable switcher when
// translations are validated.
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
